import { extensions } from '../../extensions/Extensions';
import { NineSliceSpritePipe } from './NineSliceSpritePipe';

extensions.add(NineSliceSpritePipe);
